/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, prefix the value with a minus sign. Fractions and decimal points aren't supported — whole numbers only.`)
};

const es_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, antepón un signo menos al valor. Las fracciones y los puntos decimales no se admiten — solo números enteros.`)
};

const de_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, stelle dem Wert ein Minuszeichen voran. Brüche und Dezimalpunkte werden nicht unterstützt — nur ganze Zahlen.`)
};

const nl_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, voeg een minteken toe. Breuken en decimale punten worden niet ondersteund — alleen hele getallen.`)
};

const fr_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, préfixez la valeur avec un signe moins. Les fractions et les points décimaux ne sont pas pris en charge — uniquement les nombres entiers.`)
};

const it_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, anteponi il valore con un segno meno. Frazioni e punti decimali non sono supportati — solo numeri interi.`)
};

const pt_br2_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, coloque um sinal de menos na frente do valor. Frações e pontos decimais não são suportados — apenas números inteiros.`)
};

const pt_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, prefixe o valor com um sinal de menos. Frações e pontos decimais não são suportados — apenas números inteiros.`)
};

const ja_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、値の前にマイナス記号を付けます。分数と小数点はサポートされていません。整数のみです。`)
};

const zh_nb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以，在数值前加上负号即可。不支持分数和小数点——仅支持整数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq3_a", locale)
	if (locale === "en") return en_nb_faq3_a(inputs)
	if (locale === "es") return es_nb_faq3_a(inputs)
	if (locale === "de") return de_nb_faq3_a(inputs)
	if (locale === "nl") return nl_nb_faq3_a(inputs)
	if (locale === "fr") return fr_nb_faq3_a(inputs)
	if (locale === "it") return it_nb_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq3_a(inputs)
	if (locale === "pt") return pt_nb_faq3_a(inputs)
	if (locale === "ja") return ja_nb_faq3_a(inputs)
	return zh_nb_faq3_a(inputs)
};